// extracted by mini-css-extract-plugin
export default {"wrapper-content":"style_wrapper-content__GlRKv","header":"style_header__tz5lB","title":"style_title__WGVdd","description":"style_description__R5J8q","body":"style_body__wQJEa"};